import styled, { css } from "styled-components";
import { addOpacityToColor } from "helpers";
import { colors, breakpoints } from "definitions";

import Logo from "assets/logo-sadosky.webp";

export const Container = styled.div`
  max-width: 124.5rem;
  padding-top: 2rem;

  ${breakpoints.max} {
    width: 95%;
  }

  ${breakpoints.tablet} {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 80%;
    justify-content: space-around;
  }

  ${breakpoints.mobile} {
    width: 95%;
  }
`;

export const EntryItemContainer = styled.div`
  box-shadow: ${({ showBorder }) =>
    showBorder ? "4px 8px 8px #353535" : "4px 4px 8px rgba(0, 0, 0, 0.15)"};
  border-radius: ${({ selected, mode }) =>
    selected || mode === "finalists" || mode === "winners"
      ? "6px 6px 0 0"
      : "6px"};
  background-color: #ffffff;
  border-color: ${({ showBorder }) =>
    showBorder ? `${colors.background.gray}` : ""};
  border-width: ${({ showBorder }) => (showBorder ? "5px" : "")};
  border-style: ${({ showBorder }) => (showBorder ? "solid" : "")};

  display: flex;
  align-items: center;

  height: 15rem;

  border-bottom: ${({ showBorder, selected, mode }) =>
    showBorder && selected && (mode === "finalists" || mode === "winners")
      ? `5px solid ${colors.background.gray}`
      : "none"};

  margin-bottom: ${({ selected, mode }) =>
    selected || mode === "finalists" || mode === "winners" ? "0px" : "2rem"};

  ${breakpoints.tablet} {
    flex-direction: column;
    width: 100%;
    height: auto;
    min-height: 35rem;
    margin: 2.5rem 0;
    margin-bottom: ${({ selected, mode }) =>
    selected || mode === "finalists" || mode === "winners" ? "0px" : "2rem"};
    justify-content: center;
  }
`;

export const ImageItem = styled.div`
  border-radius: 0px;
  background-image: ${({ image }) => `url(${image === "" ? Logo : image})`};
  background-repeat: no-repeat;
  background-size: 80%;
  background-position-x: center;
  background-position-y: center;
  z-index: 1;
  width: 100%;
  position: relative;

  ::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(156, 156, 153, 0.2);
    z-index: -1;
  }

  ${breakpoints.tablet} {
    border-radius: ${({ showBorder }) =>
    showBorder ? "0 0 0 0" : "0 6px 0 0 "};
    background-size: 87%;
    background-position-y: center;

    flex-basis: auto;
  }
`;

export const State = styled.div`
  background: ${({ color }) => `${color}`};
  position: relative;
  width: 15%;
  display: flex;
  align-items: center;
  border-radius: ${({ showBorder, mode, selected }) =>
    showBorder
      ? "0 0 0 0"
      : mode === "finalists" || mode === "winners" || selected
        ? "4px 0 0 0"
        : "4px 0 0 4px"};
  justify-content: center;

  ${breakpoints.tablet} {
    border-radius: 4px 0 0px 0px;
  }
`;

export const SectionOne = styled.div`
  display: flex;
  flex-direction: row; /*Change */
  height: ${({ showBorder }) => (showBorder ? "101%" : "100%")};
  width: 20%;
  margin-left: ${({ showBorder }) => (showBorder ? "-1px" : "")};

  ${breakpoints.tablet} {
    width: 100%;
    min-height: 15rem;
  }
`;

export const Section = styled.div`
  /*NEW */
  display: flex;
  flex-basis: 60%;
  justify-content: space-between;
  height: auto;

  ${breakpoints.tablet} {
    height: auto;
    flex-basis: auto;
    flex-direction: column;
    align-self: flex-start;
  }
`;

export const ItemDescription = styled.div`
  /*NEW */
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  flex-basis: 100%;

  margin-left: 2.4rem;
  position: relative;

  ${breakpoints.tablet} {
    margin: 0 auto;
    width: auto;
    padding: 1rem 2rem;
  }
`;

export const Name = styled.span`
  font-weight: bold;
  font-size: 1.8rem;
  line-height: 22px;
  color: #666666;
  margin-bottom: 0.3rem;
  margin-right: 0.5rem;

  ${breakpoints.tablet} {
    margin-top: 1rem;
    margin-bottom: 0.5rem;
  }
`;

export const Title = styled.span`
  font-weight: bold;
  font-size: 1.4rem;
  line-height: 17px;
  color: #333333;
  margin-bottom: 0.3rem;

  ${breakpoints.tablet} {
    margin-bottom: 1rem;
  }
`;

export const ProjectDescription = styled.span`
  font-weight: 600;
  color: #333333;
  font-size: 1.2rem;
  line-height: 17px;
  margin-bottom: 0.3rem;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;

  ${breakpoints.tablet} {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }
`;

export const ProjectDate = styled.span`
  font-weight: normal;
  color: #333333;
  font-size: 1.2rem;
  line-height: 17px;
  margin-bottom: 0.3rem;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;

/* Las acciones de la fila venían cada una con su propio envoltorio: el ojo en
   un <button> con estilos inline, el PDF en un <a> pelado y las demás en SVGs
   sueltos con onClick — sin foco de teclado, sin tooltip y cada una con su
   tamaño. Ahora todas pasan por el mismo botón: área de click pareja, hover y
   foco iguales, y el color lo pone el contenedor (los iconos son
   `currentColor`). El tamaño sale de acá, así que también empareja a los que
   vienen de otras grillas (la estrella y la urna, de 512). */
const iconAction = css`
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 3.6rem;
  height: 3.6rem;
  padding: 0;
  border: none;
  border-radius: 8px;
  background-color: transparent;
  color: ${colors.icons.gray};
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;

  svg {
    display: block;
    width: 2.2rem;
    height: 2.2rem;
  }

  :hover {
    background-color: ${addOpacityToColor(colors.icons.gray, 0.12)};
  }

  :focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px ${addOpacityToColor(colors.icons.gray, 0.35)};
  }

  /* El borrado es la única acción destructiva de la fila. */
  &[data-tone="danger"] {
    color: ${colors.background.red};

    :hover {
      background-color: ${addOpacityToColor(colors.background.red, 0.12)};
    }

    :focus-visible {
      box-shadow: 0 0 0 3px ${addOpacityToColor(colors.background.red, 0.35)};
    }
  }
`;

export const IconAction = styled.button`
  ${iconAction};
`;

export const IconLink = styled.a`
  ${iconAction};
`;

export const Icons = styled.div`
  display: flex;
  /* En el modo "list" la fila puede llegar a cinco acciones (ver, descargar,
     confirmar, reenviar y borrar) y el 20% de la fila no siempre les alcanza:
     sin el wrap se desbordan sobre el texto en anchos intermedios. */
  flex-wrap: wrap;
  flex-basis: 20%;
  /* Centradas en su columna, en los dos ejes: son botones del mismo tamaño,
     así que no hay nada que alinear contra el texto de la izquierda. */
  justify-content: center;
  align-items: center;
  align-content: center;
  margin-right: 10px;

  ${breakpoints.tablet} {
    margin-bottom: 1rem;
    align-self: center;
    width: ${({ selected }) => (selected ? "7rem" : "18rem")};
    margin-top: 1rem;
    flex-basis: 0;
  }
`;

// Todos los azules de esta pantalla son el del footer (`background.gray`);
// el divisor va translúcido para que no pese como un borde.
export const Divider = styled.div`
  background: ${addOpacityToColor(colors.background.gray, 0.35)};

  height: 80%;
  width: 0.1rem;

  ${breakpoints.tablet} {
    width: 90%;
    height: 0.1rem;
    background: ${addOpacityToColor(colors.background.gray, 0.35)};
  }
`;

export const ProjectSelection = styled.div`
  display: flex;
  flex-direction: row;
  flex-basis: 22.1%;
  align-items: center;
  justify-content: center;
  margin: 0 auto;

  label:first-of-type {
    margin-bottom: 0;

    span:first-of-type {
      width: 25.5px;
      height: 25.5px;
    }
  }

  ${breakpoints.laptop} {
    margin: 0 auto;
    padding: 2rem;

    label:first-of-type {
      width: 13rem;
    }
  }

  ${breakpoints.tablet} {
    height: 19.5%;

    label:first-of-type {
      width: auto;
    }
  }
`;

// El panel de confirmación de una fila no llega a los bordes del listado: va
// más angosto y con su propio redondeo, así se lee como algo que salió de esa
// fila y no como otra fila más. El hijo es el contenedor animado que arma
// `AnimatedControl`, que sólo existe mientras el panel está abierto.
export const ConfirmDrawer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  > * {
    width: 88%;
    max-width: 96rem;
    margin-bottom: 2rem;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 12px 24px rgba(8, 37, 90, 0.18);
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
